import { WithValidationProps } from "~/sharedHOC/withValidation/withValidation";
import { validationThemes } from "../validation/ValidationLabel";
import { withInlineEdit } from "./withInlineEdit";

export const inlineEditMultiSelectDefaultProps: Parameters<typeof withInlineEdit>[1] & WithValidationProps = {
    // to prevent onChange from being called in withinlineEdit.cancelAction because the value never changes until the edit is complete,
    // and not to close edit mode by esc/enter in withEditMode HOC, because multiselect handles it on its own.
    ignoreEnterEscInEditMode: true,
    saveOnChange: true, // forces to call updateAction and also triggers closeEditMode
    validationThemes: validationThemes.custom_fields_error,
    validation: null,
    alwaysEditMode: true,
};
